import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { History, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

const RECURSOS = [["ventas", "Ventas (con costo)"], ["traspasos", "Traspasos / compras"], ["cortes", "Cortes de caja"], ["gastos", "Gastos"]];

export default function ReenvioExpansion() {
  const [form, setForm] = useState({ desde: "", hasta: "", recursos: RECURSOS.map(([k]) => k) });
  const [estado, setEstado] = useState(null);
  const [lanzando, setLanzando] = useState(false);

  const cargar = useCallback(() => api.get("/integraciones/expansion/reenviar/estado").then((r) => setEstado(r.data)).catch(() => {}), []);
  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => { if (!estado?.corriendo) return; const id = setInterval(cargar, 4000); return () => clearInterval(id); }, [estado?.corriendo, cargar]);

  const toggle = (k) => setForm((f) => ({ ...f, recursos: f.recursos.includes(k) ? f.recursos.filter((x) => x !== k) : [...f.recursos, k] }));

  async function lanzar() {
    if (!window.confirm("Se reenviará a Expansión Rubí todo el histórico seleccionado. Madero y Pachuca irán valuados a lista franquicia. ¿Continuar?")) return;
    setLanzando(true);
    try {
      await api.post("/integraciones/expansion/reenviar", { desde: form.desde || null, hasta: form.hasta || null, recursos: form.recursos });
      toast.success("Reenvío iniciado en segundo plano");
      setTimeout(cargar, 1200);
    } catch (e) { toast.error(formatApiError(e)); } finally { setLanzando(false); }
  }

  const prog = estado?.progreso || {};
  const cola = estado?.cola_expansion || {};
  return (
    <div className="rounded-2xl border border-brand-line/70 p-3 space-y-3" data-testid="expansion-reenvio-panel">
      <div className="text-[10px] uppercase font-bold text-brand-muted flex items-center gap-1"><History className="w-3.5 h-3.5" /> Reenvío histórico a Expansión (P&amp;L real)</div>
      <p className="text-[11px] text-brand-slate">Reenvía ventas con <b>costo por artículo</b>, traspasos, cortes y gastos (mismo <code className="font-mono">sucursal_id</code> que las ventas). Cd Madero y Pachuca se valúan con la <b>lista franquicia</b> en compras y costo de venta; el resto con costo real.</p>
      <div className="flex flex-wrap gap-3 items-end">
        <div><label className="text-[10px] uppercase font-bold text-brand-muted">Desde</label><input data-testid="expansion-reenvio-desde" type="date" value={form.desde} onChange={(e) => setForm({ ...form, desde: e.target.value })} className="field block mt-1 text-xs h-9" /></div>
        <div><label className="text-[10px] uppercase font-bold text-brand-muted">Hasta</label><input data-testid="expansion-reenvio-hasta" type="date" value={form.hasta} onChange={(e) => setForm({ ...form, hasta: e.target.value })} className="field block mt-1 text-xs h-9" /></div>
        <div className="flex flex-wrap gap-2 pb-1">
          {RECURSOS.map(([k, lab]) => (
            <label key={k} className="flex items-center gap-1 text-xs text-brand-ink cursor-pointer"><input data-testid={`expansion-reenvio-rec-${k}`} type="checkbox" checked={form.recursos.includes(k)} onChange={() => toggle(k)} className="w-3.5 h-3.5 accent-brand-amber" />{lab}</label>
          ))}
        </div>
        <button data-testid="expansion-reenvio-lanzar" onClick={lanzar} disabled={lanzando || estado?.corriendo || !form.recursos.length} className="btn-amber h-9 px-4 text-xs">
          {(lanzando || estado?.corriendo) ? <Loader2 className="w-4 h-4 animate-spin" /> : <History className="w-4 h-4" />} {estado?.corriendo ? "Reenviando…" : "Reenviar histórico"}
        </button>
      </div>
      {estado && (estado.corriendo || estado.fin) && (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid="expansion-reenvio-progreso">
          {Object.entries(prog).map(([k, p]) => (
            <div key={k} className="rounded-xl border border-brand-line bg-brand-canvas p-2 text-center">
              <div className="text-sm font-bold text-brand-ink font-mono">{p.encolados}/{p.total}</div>
              <div className="text-[10px] text-brand-muted capitalize">{k}</div>
            </div>
          ))}
          <div className="col-span-2 sm:col-span-4 text-[11px] text-brand-muted">
            {estado.corriendo ? "Encolando eventos…" : `Último reenvío terminado ${estado.fin?.slice(0, 16).replace("T", " ")}`}{estado.error && <span className="text-rose-700"> · Error: {estado.error}</span>}
            {" · "}Cola Expansión: {cola.pendiente || 0} pendientes · {cola.enviado || 0} enviados · {(cola.error || 0) + (cola.fallido || 0)} con error
          </div>
        </div>
      )}
    </div>
  );
}
